
import HttpHelper from '../utils/http-helper';

export default class LocationModule {

	constructor(countriesModule) {
		this.countriesModule = countriesModule;

		this.locations = [];
		this.locationSelected = null;
		this.select = document.querySelector('#locationSelect');
		this.resetButton = document.querySelector('#locationResetButton');

	}

	addEventListener(callerModule) {
		this.resetButton.addEventListener('click', () => {
            if (callerModule.dataTable) callerModule.dataTable.page = 1;
            if (callerModule.dataTable) callerModule.dataTable.offset = 0;
            this.resetSelect().then(callerModule.getData());
		});
		this.select.addEventListener('change', () => {
			this.locationSelected = this.select.value;
			if (this.select.value === '') {
				this.resetButton.setAttribute('disabled', 'true');
			} else {
				this.resetButton.removeAttribute('disabled');
			}
            if (callerModule.dataTable) callerModule.dataTable.page = 1;
            if (callerModule.dataTable) callerModule.dataTable.offset = 0;
            callerModule.getData().then();
		});
	}

	async getAllData (countriesSelected) {
		if (countriesSelected.size === 0) {
			return;
		}
		const filterQuery = `{"$or": [${Array.from(countriesSelected).map((countryId) => {
			if (!countryId) {
				return '';
			} else {
				return JSON.stringify({ 'country': { $oid: countryId } });
			}
		}).join()}]}`;
		const response = await HttpHelper.fetchData(`${location.origin}/api/public/location?sort={"originName":1}&filter=${filterQuery}`);
		this.locations = response?.data;
	}

	async getId(id) {
		const response = await HttpHelper.fetchData(`${location.origin}/api/public/location/${id}`);
		return response?.data;
	}

	async resetSelect () {
		this.setAllLocationsOption();

		// loadOptions();
		if (this.countriesModule.countriesSelected.size === 0) {
			return;
		}
		if (this.countriesModule.countriesSelected.size > 0) {
			this.loadLocations();
		}
	}

	setAllLocationsOption () {
		this.select.value = '';
		this.select.innerHTML = null;
		this.locationSelected = null;
		this.resetButton.setAttribute('disabled', 'true');
		if (this.countriesModule.countriesSelected.size === 0 || this.countriesModule.countriesSelected.size === 0) {
			const defaultOption = document.createElement('OPTION');
			defaultOption.innerHTML = 'Bitte wählen Sie zunächst ein Land';
			defaultOption.value = '';
			this.select.appendChild(defaultOption);
			this.select.setAttribute('disabled', 'true');
		} else {
			const defaultOption = document.createElement('OPTION');
			defaultOption.innerHTML = 'Alle Orte';
			defaultOption.value = '';
			this.select.appendChild(defaultOption);
		}
	}

	loadLocations () {
		this.setAllLocationsOption();
		this.getAllData(this.countriesModule.countriesSelected).then(() => {

			if (this.locations.length > 0) {
                this.alternativeNames = [];
                this.outdatedNames = [];
                this.locations.forEach((location) => {
                    if(!!location.alternativeNames && location.alternativeNames?.length !== 0) {
                        location.alternativeNames.forEach((alternativeName) => {
                            if (!this.alternativeNames.includes( { _id: location._id } )) {
                                this.alternativeNames.push({
                                    _id: location._id,
                                    originName: alternativeName.nameShort
                                });
                            }
                        });
                    }
                    if(!!location.outdatedNames && location.outdatedNames?.length !== 0) {
                        location.outdatedNames.forEach((alternativeName) => {
                            if (!this.outdatedNames.includes( { _id: location._id } )) {
                                this.outdatedNames.push({
                                    _id: location._id,
                                    originName: alternativeName.nameShort
                                });
                            }
                        });
                    }
                });
                const concatArray = this.locations.concat(this.alternativeNames, this.outdatedNames);
                if (concatArray.length > 0) {
                    concatArray.sort((a, b) => {
                        let sortStatus = 0,
                            aProp = a?.originName?.toLowerCase(),
                            bProp = b?.originName?.toLowerCase();
                        if (aProp < bProp) {
                            sortStatus = -1;
                        } else if (aProp > bProp) {
                            sortStatus = 1;
                        }
                        return sortStatus;
                    });
                    concatArray.forEach((location) => {
                        const newOption = document.createElement('OPTION');
                        newOption.innerHTML = location.originName;
                        newOption.value = location._id;
                        this.select.appendChild(newOption);
                    });
                }

				this.select.value = '';
				this.select.removeAttribute('disabled');
			}
		});
	}
}

